<section class="atividade-wrapper">

  <!-- HÁBITOS -->
  <div class="box-item">
    <div class="box-header">
      <mat-checkbox
        [checked]="!!resumo?.habitoAlimentar"
        disabled
        class="checkbox-cinza">
      </mat-checkbox>

      <span class="box-title">Hábitos alimentares</span>
    </div>

    @if (!!resumo?.habitoAlimentar) {
      <div class="box-body">
        <div class="linha-data">
          Preenchido em: <b>{{ resumo!.habitoAlimentar!.data }}</b>
        </div>
      </div>
    } @else {
      <div class="sem-registro-container">
        <img src="../../../../assets/svg/icons/info_ic_azul.svg" alt="" />
        <p>O formulário de mapeamento de hábitos alimentares não foi preenchido.</p>
      </div>
    }
  </div>

  <!-- PLANO -->
  <div class="box-item">
    <div class="box-header">
      <mat-checkbox
        [checked]="!!resumo?.planoAlimentar"
        disabled
        class="checkbox-cinza">
      </mat-checkbox>

      <span class="box-title">Plano alimentar</span>
    </div>

    @if (!!resumo?.planoAlimentar) {
      <div class="box-body">
        <div class="linha-data">
          Atualizado em: <b>{{ resumo!.planoAlimentar!.data }}</b>
        </div>
      </div>
    } @else {
      <div class="sem-registro-container">
        <img src="../../../../assets/svg/icons/info_ic_azul.svg" alt="" />
        <p>Nenhum plano alimentar foi cadastrado para o participante.</p>
      </div>
    }
  </div>

  <!-- CONSULTA -->
  <div class="box-item">
    <div class="box-header">
      <mat-checkbox
        class="ck"
        [ngClass]="{ 'ck-ok': consultaMarcada && !!consultaData }"
        [checked]="consultaMarcada"
        (change)="onToggleConsulta($event.checked)">
      </mat-checkbox>

      <span class="box-title">Consulta agendada com algum profissional da saúde</span>
    </div>

    @if (consultaMarcada && consultaData) {
      <div class="box-body">
        <div class="linha-data">
          Agendado em: <b>{{ consultaData | date:'dd/MM/yyyy' }}</b>
        </div>
      </div>
    } @else {
      <div class="sem-registro-container">
        <img src="../../../../assets/svg/icons/info_ic_azul.svg" alt="" />
        <p>Nenhuma consulta agendada para o participante.</p>
      </div>
    }

    <mat-form-field appearance="outline" class="full">
      <mat-label>Observações</mat-label>
      <textarea
        matInput
        rows="4"
        [(ngModel)]="consultaObservacoes"
        minlength="15"
        maxlength="300">
      </textarea>
    </mat-form-field>
  </div>

</section>

<section class="outras">
  <p class="section-title">OUTRAS INFORMAÇÕES</p>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Escreva as informações</mat-label>
    <textarea
      matInput
      rows="3"
      [(ngModel)]="outrasInformacoes"
      minlength="15"
      maxlength="300">
    </textarea>
  </mat-form-field>
</section>

<div class="acoes">
  <button matButton="outlined" type="button" (click)="cancelar()">Cancelar</button>
  <button matButton="filled" type="button" (click)="salvar()" [disabled]="salvando">
    Salvar
  </button>
</div>
